var React = require('react');

function DateIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.998 2.25V5.25","stroke":"#194550","strokeWidth":"1.8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 2.25V5.25","stroke":"#194550","strokeWidth":"1.8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3 9H21","stroke":"#194550","strokeWidth":"1.8","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M5 4H19C20.105 4 21 4.895 21 6V19C21 20.1046 20.1046 21 19 21H5C3.895 21 3 20.105 3 19V6C3 4.895 3.895 4 5 4Z","stroke":"#194550","strokeWidth":"1.8","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

DateIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DateIcon;

DateIcon.default = DateIcon;
